export default "__VITE_ASSET__D20_ZavC__"